import React, { useEffect, useState } from 'react';
import CancelIcon from '@mui/icons-material/Cancel';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { addNewCategory, clearData, editCategory } from '../../../Redux/CategoryRedux';
import ConfirmationDialog from '../ConfirmationDialog';

function AddCategory({ categoryDialog, setCategoryDialog }) {
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem('user'));
  const adminId = user.userId;

  const { selectedCategoryRow } = useSelector((state) => state.categoryRedux);

  const [isEditing, setIsEditing] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState(false);

  const [categoryForm, setCategoryForm] = useState({
    id: '',
    category: [],
  });

  useEffect(() => {
    if (selectedCategoryRow && Object.keys(selectedCategoryRow).length > 0) {
      setCategoryForm({
        id: selectedCategoryRow.id || '',
        category: selectedCategoryRow.category || '',
      });
      setIsEditing(true);
    } else {
      setCategoryForm({
        id: '',
        category: [],
      });
      setIsEditing(false);
    }
  }, [selectedCategoryRow]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCategoryForm((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSave = (e) => {
    e.preventDefault();
    const newCategory = {
      category: categoryForm.category,
    };
    if (isEditing) {
      setConfirmDialog(true);
    } else {
      dispatch(addNewCategory(adminId, newCategory))
        .then(() => {
          setCategoryForm({
            id:"",
            category: [],
          });
          setCategoryDialog(false);
          setIsEditing(false);
        })
        .catch((error) => {
          console.error('Error in adding category:', error);
        });
      
    }
  };

  const handleClose = () => {
    setIsEditing(false);
    setCategoryForm({ id: '', category: [] });
    setCategoryDialog(false);
    setConfirmDialog(false);
    // dispatch(clearData());
  };

  const editCategoryConfirm = () => {
    const categoryData = {
      id: categoryForm.id,
      category: categoryForm.category,
    };
    dispatch(editCategory(adminId, categoryData))
      .then(() => {
        setIsEditing(false);
        setCategoryForm({
          category: [],
        });
        handleClose();
      })
      .catch((error) => {
        console.error('Error editing data:', error);
      });
  };
  return (
    <>
      <Dialog open={categoryDialog} onClose={handleClose}>
        <DialogTitle className='text-center'>
          <div>
            <h5>{isEditing ? 'Edit Category' : 'Add Category'}</h5>
          </div>
        </DialogTitle>
        <IconButton
          aria-label='close'
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 0,
            top: 0,
            color: 'black',
          }}
        >
          <CancelIcon />
        </IconButton>
        <DialogContent>
          <form>
            <div className='row'>
              <div className='col-12'>
                <label htmlFor='categoryType'>Category</label>
                <input
                  type='text'
                  id='categoryType'
                  name='category'
                  value={categoryForm.category}
                  onChange={handleChange}
                  className='form-control mb-3'
                  style={{ border: '1px solid #cccccc' }}
                  required
                />
              </div>
            </div>
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSave} variant='contained'>
            Save
          </Button>
          <Button onClick={handleClose} variant='contained'>
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <ConfirmationDialog
        open={confirmDialog}
        onClose={handleClose}
        onConfirm={editCategoryConfirm}
        description='Are you sure you want to save these changes?'
      />
    </>
  );
}

export default AddCategory;
